





































































import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table, TableRowsSelect } from "@/utils/decorator";
import { emptyToLine } from "@/utils/common";

import dayjs from "dayjs";

const base = namespace("base");
const purchase = namespace("purchase");
const setting = namespace("setting");

@Component({})
@Table("loadListData")
@TableRowsSelect({
  warningMsg: "请选择检测项目",
  updateStatusFuncName: "confirmUpdateStatus",
  tableRefKey: "table"
})
export default class ConfirmPayment extends Vue {
  @purchase.State paymentBtnLoading;
  @base.Action getDictionaryList;
  @purchase.Action getPurchaseList;
  @setting.Action getPatternPaymentList;
  @Prop()
  show: boolean;
  @Prop()
  supplierCode: string;
  dayjs = dayjs;
  formData: any = {
    settleType: 1,
    paidMethod: ""
  };
  get $suppilerCode() {
    return this.supplierCode;
  }
  emptyToLine = emptyToLine;
  payWayList: any = [];
  created() {
    this.init();
  }
  get seletedAmount() {
    return this.mix_selectedRows.reduce((prev, cur) => {
      return prev + Number(cur.purchaseAmount);
    }, 0);
  }
  formDataRules: any = {
    paidMethod: [{ required: true, message: "请选择付款方式", trigger: "change" }]
  };
  init() {
    this.getPatternPaymentList({
      status: "1"
    }).then(data => {
      this.payWayList = data.data || [];
    });
  }
  loadListData() {
    return [];
  }
  purchaseOrderList: any = [];
  handleSettleTypeChange(val) {
    if (val === 2) {
      this.getPurchaseList({
        supplierCode: this.$suppilerCode,
        settlementStatus: "0",
        pageNum: 1,
        pageSize: 999
      }).then(data => {
        this.purchaseOrderList = data.data.list;
      });
    }
  }
  handleCancel() {
    this.$emit("update:show", false);
  }
  handleConfirm() {
    if (!this.formData.paidMethod) {
      return this.$message.error("请选择付款方式");
    }
    this.$emit(
      "confirmBtnClick",
      Object.assign({}, this.formData, {
        selectedRows: this.mix_selectedRows
      })
    );
  }
}
